<template>
  <div id="mainMenu">
    <div id="siteIcon">
      <router-link tag="button" to="/">
        <img :src="require('@/assets/CSPIcon.png')" style="height: 72px"/>
      </router-link>
    </div>
    <div id="menuLinks" v-if="!mobile">
      <MenuIcon title="Company"/>
      <MenuIcon title="Capabilities"/>
      <MenuIcon title="Careers"/>
      <MenuIcon title="Contact"/>
    </div>
    <div id="collapseMenu" v-else>
      <button class="dropBtn" v-on:click="openMenu()">
        <img id="dropBtnImg" :src="require('@/assets/hamburgerMenu.png')"/>
      </button>
      <div class="dropdown-content" id="dropMenu">
        <router-link to="/Company">Company</router-link>
        <router-link to="/Capabilities">Capabilities</router-link>
        <router-link to="/Careers">Careers</router-link>
        <router-link to="/Contact">Contact</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import MenuIcon from '@/components/Menu/MenuIcon'

export default {
  name: 'MainMenu',
  data () {
    return {
      mobile: false
    }
  },
  components: {
    MenuIcon
  },
  created () {
    window.addEventListener('resize', this.handleResize)
    window.addEventListener('mouseup', this.hideMenu)
    this.handleResize()
  },
  methods: {
    handleResize: function () {
      if ($(document).width() <= 720) {
        this.mobile = true
      } else {
        this.mobile = false
      }
      $('#dropMenu').css('margin-left', $(document).width() - $('#dropMenu').width())
      $('#dropMenu').css('display', 'none')
    },
    openMenu: function () {
      if ($('#dropMenu').css('display') === 'block') {
        $('#dropMenu').css('display', 'none')
      } else {
        $('#dropMenu').css('margin-left', $(document).width() - 160)
        $('#dropMenu').css('margin-top', 72)
        $('#dropMenu').css('display', 'block')
      }
    },
    hideMenu: function (event) {
      if (event.target.id !== 'dropBtnImg' && $('#dropMenu').css('display') === 'block') {
        $('#dropMenu').css('display', 'none')
      }
    }
  },
  destroyed () {
    window.removeEventListener('resize', this.handleResize)
    window.removeEventListener('mouseup', this.hideMenu)
  }
}
</script>

<style>
  #mainMenu {
    height: 72px;
    padding-right: 50px;
    box-shadow: 0 2px 10px gray;
  }
  #siteIcon {
    float: left;
    height: 100%;
  }
  #siteIcon button {
    height: 100%;
    border: none;
    background: none;
    outline: none;
    cursor: pointer;
  }
  #menuLinks {
    float: right;
    height: 100%;
  }
  #collapseMenu button {
    float: right;
    height: 72px;
    border: none;
    padding: 0;
    background: none;
    outline: none;
    cursor: pointer;
  }
  #collapseMenu img {
    height: 100%;
  }

  .dropdown-content {
    display: none;
    position: absolute;
    background-color: #f9f9f9;
    min-width: 160px;
    box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
    z-index: 1;
  }

  .dropdown-content a {
    float: none;
    color: black;
    padding: 12px 16px;
    text-decoration: none;
    display: block;
    text-align: left;
  }

  .dropdown-content a:hover {
    background-color: #ddd;
  }

  .show {
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/components/Menu/MainMenu.vue